import React, { Component } from 'react';
import AdministratorsApi from '../../api/administrators';

class GenerateReport extends Component {
  state = {
    start: '',
    end: '',
    error:""
  };

  handleChange = (evt) => {
    const {
      target: { name, value },
    } = evt;
    if (name === 'start') {
      this.setState({ end: '' });
    }
    this.setState({
      [name]: value,
    });
  };

  handleDownloadReport = async () => {
    try {
      this.setState({error: ''})
      const query = `?start_date=${this.state.start}&end_date=${this.state.end}`;
      await AdministratorsApi.downloadCfpUsers(query);
    } catch (error) {
      this.setState({ error: error.message });
    }
  };
  render() {
    return (
      <>
        <section className='animated fadeIn wide'>
          <header>
            <h1>CFP</h1>
            <div className='actions'></div>
          </header>
        </section>
        <div
          style={{
            width: '800px',
            margin: 'auto',
          }}
        >
          <p className='mb-2'> Select Date Range</p>
          <div className='row mb-2'>
            <div
              className='col-6'
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <label className='mr-8' htmlFor='start'>
                Start Date
              </label>
              <input
                type='date'
                min='2022-12-07'
                id='start'
                value={this.state.start}
                name='start'
                onChange={this.handleChange}
              />
            </div>
            <div
              className='col-6'
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <label className='mr-8' htmlFor='end'>
                End Date
              </label>
              <input
                type='date'
                min={this.state.start}
                id='end'
                value={this.state.end}
                name='end'
                onChange={this.handleChange}
                readOnly={!this.state.start ? true : false}
              />
            </div>
          </div>
          {this.state.error && <p style={{color: "red", fontWeight:"700"}}>{ this.state.error}</p>}
          <button
            onClick={this.handleDownloadReport}
            className='btn btn-secondary'
          >
            Generate Report
          </button>
        </div>
      </>
    );
  }
}

export default GenerateReport;
